// extracted by mini-css-extract-plugin
export default {"shadowBlockInner":"Layout_shadowBlockInner__Vxic7","container":"Layout_container__o7UwR"};